import React from "react";
import Reveal from "../../components/reveal/Reveal";
import "./about.css";

/* Presented as a record rather than a grid of blurbs: a donor scanning for
   "who are these people and where does the money go" gets an answer per row. */
const RECORD = [
  {
    label: "Mission",
    body: (
      <>
        Empower marginalised and vulnerable communities — especially children
        and persons with disabilities — through inclusive health, education and
        livelihood services.
      </>
    ),
  },
  {
    label: "What we run",
    body: (
      <>
        Health awareness programmes, physiotherapy sessions, and financial help
        towards treatment for people recovering from stroke. We also work with
        schools so disabled children can get the medical care they need without
        leaving the classroom.
      </>
    ),
  },
  {
    label: "Funded by",
    body: (
      <>
        Member subscriptions, individual donations, and corporate social
        responsibility support from organisations including{" "}
        <a
          href="https://www.facebook.com/paincare.smileface"
          target="_blank"
          rel="noopener noreferrer"
          className="about__link"
        >
          SPRC Barishal
        </a>
        .
      </>
    ),
  },
  {
    label: "How we are run",
    body: (
      <>
        An active managing committee, trained staff, and transparent
        record-keeping — the basis on which we ask people to trust us with a
        donation.
      </>
    ),
  },
];

const About = () => (
  <section className="section about" id="whatsprc" aria-labelledby="about-title">
    <div className="shell">
      <p className="marker">
        <span className="marker__num">01</span>
        <span>Who we are</span>
      </p>

      <div className="about__inner">
        <Reveal className="about__lede">
          <h2 id="about-title" className="t-display-2 about__title">
            A small organisation doing specific, unglamorous work.
          </h2>
          <p className="t-lead about__lead">
            SALES has been working in Barishal for over two years.
          </p>
          <blockquote className="pull-quote about__quote">
            The people we serve are mostly stroke survivors, people living with
            paralysis, and children with disabilities whose families cannot
            absorb the cost of long-term care.
          </blockquote>
          <a className="link-arrow about__cta" href="#possibility">
            Support this work
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M2 8h12m0 0-4.5-4.5M14 8l-4.5 4.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </Reveal>

        <Reveal as="dl" className="meta about__record" stagger={90} distance={16}>
          {RECORD.map((row) => (
            <div className="meta__row" key={row.label}>
              <dt>{row.label}</dt>
              <dd>{row.body}</dd>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
